import React from 'react';
import { Button, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { ModalTitle } from 'components/index';
import { useTranslation } from 'react-i18next';

import styles from './TwoOptionsDialog.module.scss';

export interface TwoOptionsDialogProps extends DialogProps {
  title?: string;
  text: string | JSX.Element;
  cancelText?: string;
  confirmText?: string;
  hideCancelButton?: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

export function TwoOptionsDialog({
  title,
  text,
  cancelText,
  confirmText,
  hideCancelButton,
  onConfirm,
  onClose,
  ...rest
}: TwoOptionsDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog {...rest} maxWidth={false} fullWidth={false} className={styles.dialog}>
      {title && (
        <DialogTitle>
          <ModalTitle title={title} onClose={onClose} />
        </DialogTitle>
      )}

      <DialogContent>
        {text instanceof String ? (
          <Typography component='p' variant='body2'>
            {text}
          </Typography>
        ) : (
          text
        )}

        <Stack direction='row' alignItems='center' className={styles.actionsRow}>
          {!hideCancelButton && (
            <Button variant='outlined' className={styles.formButton} onClick={onClose}>
              {cancelText ?? t('cancel', { ns: 'auth' })}
            </Button>
          )}
          <Button variant='contained' className={styles.formButton} onClick={onConfirm}>
            {confirmText ?? t('ok', { ns: 'auth' })}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
